import './App.css';
import Header from './components/Header';
import Images from './components/Images';
import LiveChannel from './components/LiveChannel';
import Videos from './components/Videos';

function App() {
	return (
		<div className='bg-[#0b025f] min-h-screen'>
			<Header />
			<LiveChannel />
			<Videos />
			<Images />
		</div>
	);
}

export default App;
